import { render, staticRenderFns } from "./area-rules-summary-dialog.component.vue?vue&type=template&id=7085bc7a"
import script from "./area-rules-summary-dialog.component.ts?vue&type=script&lang=ts&external"
export * from "./area-rules-summary-dialog.component.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/foex-3r/foex-3r-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7085bc7a')) {
      api.createRecord('7085bc7a', component.options)
    } else {
      api.reload('7085bc7a', component.options)
    }
    module.hot.accept("./area-rules-summary-dialog.component.vue?vue&type=template&id=7085bc7a", function () {
      api.rerender('7085bc7a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/shared/area-rules-summary-dialog/area-rules-summary-dialog.component.vue"
export default component.exports